// const shortcutEditLeft = {
//     xs: '8%',
//     sm: '36px',
//     md: '33px',
//     lg: '40px',
//     xl: '42px'
// }

// const shortcutPaperHeight = {
//     xs: '',
//     sm: '100%',
//     md: '100%',
//     lg: '100%',
//     xl: 'calc(100vh - 40px)'
// }

// [SLB] 'sl' breakpoint (theme.js:36 = 1300..1366) had no entry in any map here.
// See ClalNewDesignFinalVersion/CHANGE-REGISTRY-2026-08-20.md section G.
const shortcutBoxWidth = {
    xs: 'auto',
    sm: '92.1%',
    md: '92.1%',
    sl: '92.1%',
    lg: '92.1%',
    xl: 'auto'
}


export const getDashboardStyle = (windowSize, isRTL, theme) => ({
        dashboardTablet: {
            background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
            padding: windowSize === 'xs' ? '8px' : '16px',
            borderRadius: '18px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            maxWidth: '900px',
            margin: '0 auto',
            minHeight: 'calc(100vh - 32px)',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
        },
    mobileReportHead: {
        fontWeight: 'bold',
        marginTop: 10,
        // marginInlineStart: 10
    },
    tabelCellPadding: {
        paddingBlock: 15
    },
    dashboard: {
        background: 'transparent',
        padding: 0,
        maxHeight: 'unset',
    },
    chartLabelGreen: {
        position: 'absolute',
        top: 'calc(50% - 28px)',
        width: '100%',
        fontSize: 35,
        fontWeight: '500',
        textTransform: 'uppercase',
        color: '#65d638'
    },
    shortcutTitle: {
        maxHeight: 30,
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        marginBottom: 10,
    },
    shortcutSubtitle: {
        fontSize: windowSize === 'xs' ? 16 : 18,
        padding: '0 10px 0 10px',
        marginBottom: 15,
        maxHeight: '10%'
    },
    shortcutBox: {
        borderRadius: 20,
        background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
        marginBottom: 19,
        overflow: 'hidden',
        // position: windowSize !== 'xl' && windowSize !== 'xs' ? 'block' : 'sticky',
        // top: windowSize !== 'xl' ? 47 : 0,
        // right: isRTL ? 'auto' : 0,
        // left: isRTL ? 0 : 'auto',
        width: shortcutBoxWidth[windowSize],
        height: '100%',
        maxHeight: '730px',
        margin: '30px auto 19px',
        marginTop: windowSize !== 'xs' ? 30 : '',
        [theme.breakpoints.down('xs')]: {
            margin: '10px 10px 10px 10px',
            maxHeight: 'calc(100% - 50px)',
        },
        border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '3px solid #F0F5FF',
        '& .MuiPaper-rounded': {
            scrollbarWidth: 'none',
            overflow: 'auto',
            '-ms-overflow-style': 'none' /* IE 11 */
        }
    },
    shortcutPaper: {
        [theme.breakpoints.down('xs')]: {
            borderRadius: 10,
        },
        // height: shortcutPaperHeight[windowSize],
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '0px'
        },
        '&::-webkit-scrollbar-thumb': {
            'backgroundColor': 'darkgrey',
            borderRadius: '5px'
        },
        scrollbarWidth: 'none',
        '-ms-overflow-style': 'none', /* IE 11 */
        ['@media (max-width:1280px)']: {
            height: '100%',
            overflow: 'hidden'
        },
    },
    shortcutBtnBox: {
        position: 'relative',
        width: '100%',
        textAlign: 'center'
    },
    shortcutButton: {
        height: 90,
        width: '85%',
        background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
        borderRadius: '20px',
        marginBottom: windowSize === 'xs' ? 30 : 25,
        fontSize: '18px',
        position: 'relative',
        textTransform: 'capitalize',
        // padding: '6px 30px',
        // Dark: neutral card, pink text/border only on hover/focus.
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#FF0054',
        border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.borderSubtle}` : '3px solid #FF0076',
        boxShadow: 'none',
        '& .MuiDivider-root': {
            width: '100%',
            border: theme.palette.type === 'dark' ? `1px ${theme.custom.borderSubtle} solid` : '1px #FF0054 solid',
            height: 0,
            margin: '5px 0'
        },
        '& .shortcutEditIcon': {
            fontFamily: 'pulseemicons',
            fontSize: 16,
            color: theme.palette.type === 'dark' ? theme.custom.brandPrimary : '#FF0054',
            padding: 0,
            '&:hover': {
                textDecoration: 'none',
            }
        },
        '& .deleteShortcut': {
            maxHeight: 20,
            zIndex: 100,
            opacity: 0,
            PointerEvent: 'none',
            marginTop: -15,
            color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#707070',
            fontSize: 20,
            cursor: 'pointer',
            '&:hover': {
                textDecoration: 'none',
            }
        },
        '&:hover': {
            background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
            boxShadow: 'none',
            ...(theme.palette.type === 'dark' ? { borderColor: theme.custom.brandPrimary } : {}),
            '& .deleteShortcut': {
                opacity: 1,
                PointerEvent: 'all',
            }
        },
        ...(theme.palette.type === 'dark' ? { '&.Mui-focusVisible': { borderColor: theme.custom.brandPrimary } } : {}),
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            height: 82,
            marginBottom: 18,
            borderRadius: 12,
        },

    },
    shortcutDottedButton: {
        borderRadius: '20px',
        color: theme.palette.type === 'dark' ? theme.custom.brandPrimary : '#FF0076',
        border: theme.palette.type === 'dark' ? `1px dashed ${theme.custom.borderControl}` : '1px dashed #FF0076',
        fontFamily: 'pulseemicons',
        height: 90,
        fontSize: '30px',
        marginBottom: 25,
        width: '85%',
        '&:hover': {
            background: 'none'
        }
        ,
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            height: 82,
            marginBottom: 18,
            borderRadius: 12,
        }
    },
    shortcutList: {
        maxWidth: 350,
        background: theme.palette.type === 'dark' ? theme.custom.surface : 'white',
        borderRadius: 10,
        margin: 10
    },
    shortcutLabel: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        marginTop: -5
    },
    shortcutStripBox: {
        margin: '30px 30px 0 30px',
        borderRadius: 20,
        border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '3px solid #F0F5FF',
        background: theme.palette.type === 'dark' ? theme.custom.surface : '#fff',
        overflow: 'hidden',
        display: 'block',
        [theme.breakpoints.down('xs')]: {
            margin: '10px 10px 0 10px',
        },
    },
    shortcutStripHeader: {
        marginBottom: 0,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        height: '20% !important',
        maxHeight: 'none !important',
        padding: '6px 10px !important',
    },
    // Pill / chip styles
    pillScroller: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        padding: '12px 14px 16px',
        boxSizing: 'border-box',
        // theme.breakpoints here resolves against MUI's default theme (App's own MuiThemeProvider
        // doesn't wrap App's own render body), so the real 'lg' value (1367, from theme.js) is hardcoded.
        ['@media (min-width:1367px)']: {
            flexDirection: 'column',
            flexWrap: 'nowrap',
        },
    },
    pillItem: {
        position: 'relative',
        width: 'calc(50% - 4px)',
        minWidth: 0,
        boxSizing: 'border-box',
        ['@media (min-width:1367px)']: {
            width: '100%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%'
        },
    },
    pillChip: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        minHeight: 42,
        borderRadius: 999,
        border: '2px solid',
        padding: '4px 10px',
        width: '100%',
        boxSizing: 'border-box',
        transition: 'box-shadow 0.15s, transform 0.15s',
        ...(theme.palette.type === 'dark' ? {
            borderColor: theme.custom.borderSubtle,
            background: theme.custom.surfaceElevated,
            transition: 'box-shadow 0.15s, transform 0.15s, border-color 0.15s',
        } : {}),
        '&:hover': {
            boxShadow: '0 4px 14px rgba(0,0,0,0.10)',
            transform: 'translateY(-2px)',
            ...(theme.palette.type === 'dark' ? { borderColor: theme.custom.brandPrimary } : {}),
        },
    },
    pillIconCircle: {
        width: 28,
        height: 28,
        borderRadius: '50%',
        background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        // Dark: the icon is the card's only brand-colored element. The icons hardcode gray fills,
        // which tokens.css's global #root svg rule (an id selector) repaints white, hence !important.
        ...(theme.palette.type === 'dark' ? {
            '& svg :is([fill]:not([fill="none"]):not([fill="white" i]):not([fill="#fff" i]):not([fill="#ffffff" i]))': {
                fill: 'currentColor !important',
            },
        } : {}),
    },
    pillTextBlock: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minWidth: 0,
        flex: 1,
        overflow: 'hidden',
    },
    pillCategory: {
        fontSize: 10,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
    },
    pillTitle: {
        fontSize: 12,
        fontWeight: 500,
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: 1.3,
    },
    pillActions: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        marginLeft: 4,
        transition: 'opacity 0.15s',
        '& .shortcutEditIcon': {
            fontFamily: 'pulseemicons',
            fontSize: 13,
            color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#888',
            padding: 2,
            '&:hover': { color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#333' },
        },
        '& .deleteShortcut': {
            fontSize: 13,
            color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#888',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            padding: 2,
            '&:hover': { color: theme.palette.type === 'dark' ? theme.custom.statusError : '#e63946' },
        },
    },
    pillActionBtn: {
        padding: '2px !important',
        minWidth: 'unset',
    },
    pillMoreBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        minHeight: 42,
        borderRadius: 999,
        border: theme.palette.type === 'dark' ? `2px solid ${theme.custom.borderSubtle}` : '2px solid #6C63FF',
        background: theme.palette.type === 'dark' ? theme.custom.surfaceElevated : '#F0EEFF',
        padding: '4px 10px',
        width: '100%',
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'background 0.15s',
        '&:hover': theme.palette.type === 'dark' ? {
            background: theme.custom.surfaceElevated,
            borderColor: theme.custom.brandPrimary,
        } : {
            background: '#e4e1ff',
        },
    },
    pillMoreLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#6C63FF',
        whiteSpace: 'nowrap',
    },
    pillPopoverPaper: {
        padding: '10px 10px 6px',
        width: 280,
        maxHeight: 300,
        overflowY: 'auto',
        borderRadius: '14px !important',
        boxShadow: '0 8px 32px rgba(0,0,0,0.16) !important',
        border: theme.palette.type === 'dark' ? `1px solid ${theme.custom.border}` : '1px solid #ececec',
        // MuiPopover's Paper never set its own background either — same frozen-light
        // gotcha as BaseDialog/MuiAccordion.
        ...(theme.palette.type === 'dark' ? {
            backgroundColor: theme.custom.surface,
            color: theme.custom.textPrimary,
        } : {}),
        marginInlineStart: 8,
        '&::-webkit-scrollbar': { width: 4 },
        '&::-webkit-scrollbar-thumb': { background: '#d6ddeb', borderRadius: 999 },
        scrollbarWidth: 'thin',
    },
    pillPopoverTitle: {
        fontSize: 10,
        fontWeight: 700,
        color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#aaa',
        textTransform: 'uppercase',
        letterSpacing: '0.06em',
        marginBottom: 8,
        paddingInlineStart: 4,
    },
    pillPopoverList: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
    },
    pillPopoverChip: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        minHeight: 42,
        borderRadius: 999,
        border: '2px solid',
        padding: '4px 10px',
        width: '100%',
        boxSizing: 'border-box',
        overflow: 'hidden',
        cursor: 'pointer',
        transition: 'box-shadow 0.15s',
        ...(theme.palette.type === 'dark' ? {
            borderColor: theme.custom.borderSubtle,
            background: theme.custom.surfaceElevated,
            transition: 'box-shadow 0.15s, border-color 0.15s',
        } : {}),
        '&:hover': {
            boxShadow: '0 4px 14px rgba(0,0,0,0.10)',
            ...(theme.palette.type === 'dark' ? { borderColor: theme.custom.brandPrimary } : {}),
        },
    },
    pillPopoverItem: {
        position: 'relative',
        width: '100%',
        minWidth: 0,
        boxSizing: 'border-box',
    },
    pillAddChip: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minHeight: 42,
        borderRadius: 999,
        border: theme.palette.type === 'dark' ? `2px dashed ${theme.custom.borderControl}` : '2px dashed #FF2D76',
        padding: '4px 10px',
        width: '100%',
        boxSizing: 'border-box',
        cursor: 'pointer',
        transition: 'background 0.15s',
        '&:hover': theme.palette.type === 'dark' ? {
            background: theme.custom.brandTint,
            borderColor: theme.custom.brandPrimary,
        } : {
            background: '#fff7fb',
        },
    },
    pillAddLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: theme.palette.type === 'dark' ? theme.custom.textSecondary : '#FF2D76',
        whiteSpace: 'nowrap',
    },

    dashboardTop: {
        [theme.breakpoints.down('sm')]: {
            order: 1
        },
    },
    dashboardSide: {
        // paddingRight: isRTL ? 0 : 30,
        // paddingLeft: !isRTL ? 0 : 30,
        [theme.breakpoints.down('sm')]: {
            order: 2,
            padding: 0,
            display: 'flex',
            justifyContent: 'center'
        },
    },
    transitionElem: {
        transition: ' ease-in-out .4s'
    },
    tabTitle: {
        color: theme.palette.type === 'dark' ? theme.custom.textPrimary : '#000',
        fontSize: 32,
        textAlign: 'center',
        lineHeight: '1.1'
    },
    createButton: {
        backgroundColor: '#27AE60',
        '&:hover': {
            backgroundColor: '#219150'
        }
    },
    paymentDialog: {
        maxWidth: 480,
        '& .MuiIconButton-colorSecondary': {
            color: theme.palette.type === 'dark' ? theme.custom.accentBlue : '#0371ad'
        },
        '& .MuiFormControlLabel-root': {
            marginRight: 0
        }
    },
    shoppingCartIcon: {
        fontSize: 24,
        marginBottom: -6
    }
});